import { EmptyState } from '@humanforce/mango-ui-react';

interface SuperannuationPlaceholderProps {
  title: string;
}

export const SuperannuationPlaceholder = ({ title }: SuperannuationPlaceholderProps) => (
  <div className="mgo-stack mgo-justify-center mgo-align-center mgo-padding-m" style={{ minHeight: '16rem' }}>
    <EmptyState title={title} description="This screen is coming soon." />
  </div>
);
